const gTagConstants = {
  eventKeys: {
    recently_signed_in: 'global_log_in',
    recently_signed_up: 'global_sign_up',
    first_visit: 'first_visit',
    session_start: 'session_start',
    page_view: 'page_view',
    scroll: 'scroll',
    search_filter_filled: 'search_filter_filled',
    search_bar_filled: 'search_bar_filled',
    buy_now_button_click: 'buy_now_button_click',
    place_order_button_click: 'place_order_button_click',
    place_bid_button_click: 'place_bid_button_click',
    bid_confirm_button_click: 'bid_confirm_button_click',
    sell_now_button_click: 'sell_now_button_click',
    place_ask_button_click: 'place_ask_button_click',
    confirm_sale_button_click: 'confirm_sale_button_click',
    global_to_bottle_button_click: 'global_to_bottle_button_click',
    whisky_category_button_click: 'whisky_category_button_click',
    gin_category_button_click: 'gin_category_button_click',
    rum_category_button_click: 'rum_category_button_click',
    other_category_button_click: 'other_category_button_click',
    global_brand_button_click: 'global_brand_button_click',
    global_country_button_click: 'global_country_button_click',
    newsletter_signup_button_click: 'newsletter_signup_button_click',
    instagram_button_click: 'instagram_button_click',
    tiktok_button_click: 'tiktok_button_click',
    facebook_button_click: 'facebook_button_click',
    youtube_button_click: 'youtube_button_click',
    wishlist_button_click: 'whishlist_button_click',
    add_wishlist_button_click: 'add_whishlist_button_click',
    portfolio_button_click: 'portfolio_button_click',
    add_portfolio_button_click: 'add_portfolio_button_click',
    sign_in_button_click: 'sign_in_button_click',
    sign_up_button_click: 'sign_up_button_click',
    global_sign_up: 'global_sign_up',
    become_seller_button_click: 'become_seller_button_click',
    global_selling_sign_up: 'global_selling_sign_up',
    match_page_view: 'match_page_view',
    authentication_page_view: 'authentication_page_view',
    payout_page_view: 'payout_page_view',
    purchase: 'purchase',
    arrival_confirmed_button_click: 'arrival_confirmed_button_click',
    search_result_click: 'search_result_click',
    filter_activate: 'filter_activate',
  },
};

export default gTagConstants;
